module.exports = __webpack_public_path__ + "static/media/ecommerceVendasOnline.5c832716.png";